import React, { useEffect, useState } from "react";
import { LogoLockup } from "./Logo";
import { COMPANY } from "@/lib/data";
import { Phone } from "lucide-react";

const NAV = [
  { id: "chantiers", label: "Nos chantiers" },
  { id: "solutions", label: "Solutions" },
  { id: "mission", label: "Notre approche" },
  { id: "partenaires", label: "Partenaires" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#fdfbf7]/85 backdrop-blur-md border-b border-[#e2d9ce]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto flex items-center justify-between px-6 lg:px-10 py-4">
        <button
          onClick={() => scrollTo("top")}
          data-testid="header-logo-btn"
          className="flex items-center"
          aria-label="Retour en haut"
        >
          <LogoLockup compact />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="text-sm text-[#334155] hover:text-[#0F172A] transition-colors relative group"
            >
              {n.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 bg-[#2D7A4D] group-hover:w-full transition-all duration-500" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="header-phone"
            className="hidden md:inline-flex items-center gap-2 text-sm text-[#0F172A] font-medium"
          >
            <Phone className="h-4 w-4 text-[#2D7A4D]" />
            <span>{COMPANY.phone}</span>
          </a>
          <button
            data-testid="header-cta-devis"
            onClick={() => scrollTo("contact")}
            className="btn-accent text-sm"
          >
            Devis gratuit
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden inline-flex flex-col gap-1 p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            <span className="h-0.5 w-5 bg-[#0F172A]" />
            <span className="h-0.5 w-5 bg-[#0F172A]" />
            <span className="h-0.5 w-5 bg-[#0F172A]" />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#fdfbf7] border-t border-[#e2d9ce] px-6 py-4 flex flex-col gap-3">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-mobile-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="text-left text-base text-[#0F172A] py-2 border-b border-[#f0e9dd]"
            >
              {n.label}
            </button>
          ))}
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            className="text-sm text-[#2D7A4D] font-semibold pt-2"
          >
            {COMPANY.phone}
          </a>
        </div>
      )}
    </header>
  );
}
